import React from 'react';

import BobCancelButton from '../../../components/BobCancelButton';
import BobModal from '../../../components/BobModal';

import * as classes from './RuleActionModal.module.css';

const RuleActionModal = ({
    isContextMenuClick,
    onCloseModal,
    menuActionClickType,
    selectedItems,
    selectedRule,
    handleDeleteRule,
    handleDuplicateRule,
    handleMultipleRuleActionConfirm,
    ...props
}) => {
    const onConfirm = () => {
        if (isContextMenuClick) {
            if (menuActionClickType === 'delete') {
                handleDeleteRule();
            } else if (menuActionClickType === 'duplicate') {
                handleDuplicateRule();
            }
        } else {
            handleMultipleRuleActionConfirm(menuActionClickType);
        }
    };

    const closeModal = () => {
        onCloseModal(false);
    };
    
    const getTitle = () => {
        if (isContextMenuClick || Object.keys(selectedItems).length === 1 ) {
            return {
                title: `${menuActionClickType} Rule`,
                info:  `Are you sure you want to ${menuActionClickType} the rule?`
            };
        } else {
            return {
                title: `${menuActionClickType} Rule(s)`,
                info:  `Are you sure you want to ${menuActionClickType} the rule(s)?`
            };
        }
    };
    
    const renderSelectedList = () => {
        let list = [];
        for (const id in selectedItems) {
            list.push(<li key={id}>{selectedItems[id].name}</li>);
        }

        return <ul>{ list }</ul>;
    };

    const { title, info } = getTitle();

    return (
        <BobModal
            title={title}
            hidebuttons={true}
            headerOverride={classes.HeaderOverride}
            isRemoveFooter={true}
            onClose={() => closeModal()}
        >
            <div className={classes.RuleActionModal}>
                <div className={classes.Label}>
                    Rule:
                </div>
                <div className={classes.Value}>
                    {
                        isContextMenuClick ?
                            <ul>
                                <li>{selectedRule.name}</li>
                            </ul> 
                            : renderSelectedList()
                    }
                </div>
            </div>
            <p className={classes.Info}>
                {info}
            </p>
            <div className={classes.ButtonContainer}>
                <div className={classes.Button}>
                    <BobCancelButton
                        onClick={() => onConfirm()}
                        className={classes.CancelButton}
                        label={'Yes'}
                    />
                </div>
                <div className={classes.Button}>
                    <BobCancelButton
                        onClick={() => closeModal()}
                        className={classes.CancelButton}
                        label={'No'}
                    />
                </div>
            </div>
        </BobModal>
    );
};

export default RuleActionModal;
